<div class="not-activated">
  <div class="header">
    <div class="logo">
      <img alt="logo-img" class="logo" [src]="companyLogo" />
    </div>
  </div>
  <div class="content">
    <div class="message-box">
      <app-svg-icon src="./assets/icons/ico_email.svg"></app-svg-icon>
      <div class="main-text">Sie haben es fast geschafft!</div>
      <div class="sub-text">
        Wir haben Ihnen eine <b>Einladung</b> per <b>E-Mail mit einem Link</b> gesendet. Bitte klicken Sie diesen Link an, um Ihre
        <b>Registrierung</b> erfolgreich abzuschließen.
      </div>
    </div>
  </div>
</div>
